import Router from "vue-router";

const routerPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch((err) => {});
};

let routes = [
  {
    path:"/",
    name:"home",
    meta: { showNav: true,bannerSta:true,footSta:true,topSta:true },
    component:()=>import('@/view/home.vue')
  },{
    path:"/scheme",
    name:"scheme",
    meta: { showNav: true,bannerSta:true,footSta:true },
    component:()=>import('@/view/scheme.vue')
  },
  // {
  //   path:"/report",
  //   name:"report",
  //   meta: { showNav: true,bannerSta:true,footSta:true,topSta:true },
  //   component:()=>import('@/view/report.vue')
  // },
  {
    path:"/collection",
    name:"collection",
    meta: { showNav: true,bannerSta:true,footSta:true,topSta:true },
    component:()=>import('@/view/collection.vue')
  },
  // {
  //   path:"/othor",
  //   name:"othor",
  //   meta: { showNav: true,bannerSta:true,footSta:true,topSta:true },
  //   component:()=>import('@/view/othor.vue')
  // },
  {
    path:"/info",
    name:"info",
    meta: { showNav: true,bannerSta:false,footSta:true,topSta:true },
    component:()=>import('@/view/othor/info.vue')
  },{
    path:"/upload",
    name:"upload",
    meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
    component:()=>import('@/view/othor/upload.vue')
  },{
    path:"/vip",
    name:"vip",
    meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
    component:()=>import('@/view/othor/vip.vue')
  },{
    path:"/collectionInfo",
    name:"collectionInfo",
    meta: { showNav: true,bannerSta:false,footSta:true,topSta:true },
    component:()=>import('@/view/othor/collectionInfo.vue')
  },{
    path:"/colInfo",
    name:"colInfo",
    meta: { showNav: true,bannerSta:false,footSta:true,topSta:true },
    component:()=>import('@/view/othor/colInfo.vue')
  },{
    path:"/userhome",
    name:"userhome",
    meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
    component:()=>import('@/view/othor/userHome.vue')
  },{
    path:"/agreementAll",
    name:"agreementAll",
    meta: { showNav: false,false:true,footSta:false,topSta:false },
    component:()=>import('@/view/othor/agreementAll.vue')
  },{
    path:"/advertisement",
    name:"advertisement",
    meta: { showNav: false,false:true,footSta:false,topSta:false },
    component:()=>import('@/view/othor/advertisement.vue')
  },{
    path: "/set",
    name: "set",
    meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
    component:()=>import('@/view/set/index.vue'),
    redirect:"/evaluate",
    children: [
      {
        path:"/evaluate",
        name:"evaluate",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/set/evaluate.vue')
      },{
        path:"/about",
        name:"about",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/set/about.vue')
      },{
        path:"/copyright",
        name:"copyright",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/set/copyright.vue')
      },{
        path:"/agreement",
        name:"agreement",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/set/agreement.vue')
      },{
        path:"/problem",
        name:"problem",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/set/problem.vue')
      },{
        path:"/mobileterminal",
        name:"mobileterminal",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/set/mobileterminal.vue')
      },
    ],
  },
  {
    path: "/index",
    name: "index",
    meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
    component:()=>import('@/view/user/index.vue'),
    redirect:"/user",
    children: [
      {
        path:"/user",
        name:"user",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/user.vue')
      },{
        path:"/creation",
        name:"creation",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/creation.vue')
      },{
        path:"/authentication",
        name:"authentication",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/authentication.vue')
      },{
        path:"/promotion",
        name:"promotion",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/promotion.vue')
      },{
        path:"/team",
        name:"team",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/team.vue')
      },{
        path:"/distribution",
        name:"distribution",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/distribution.vue')
      },{
        path:"/member",
        name:"member",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/member.vue')
      },{
        path:"/wallet",
        name:"wallet",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/wallet.vue')
      },{
        path:"/announcement",
        name:"announcement",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/announcement.vue')
      },{
        path:"/information",
        name:"information",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/information.vue')
      },{
        path:"/points",
        name:"points",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/points.vue')
      },{
        path:"/withdraw",
        name:"withdraw",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/withdraw.vue')
      },{
        path:"/addpoints",
        name:"addpoints",
        meta: { showNav: true,bannerSta:true,footSta:false,topSta:true },
        component:()=>import('@/view/user/addpoints.vue')
      }
    ],
  },
];

let router = new Router({
  routes,
});

export default router;
